import { z } from 'zod';

export const configSchema = z.looseObject({
  ui: z.looseObject({
    version: z.string().min(1, 'ui.version cannot be empty'),
    s3_url: z.string().min(1, 'ui.s3_url cannot be empty'),
  }),
  platform_url: z.string().min(1, 'platform_url cannot be empty'),
  powerscribe: z.looseObject({
    enabled: z.boolean(),
    polling: z.looseObject({
      enabled: z.boolean(),
    }),
    soap: z.looseObject({}),
  }),
});

export type Config = z.infer<typeof configSchema>;

export function validateConfig(parsed: unknown): string | null {
  const result = configSchema.safeParse(parsed);
  if (!result.success) {
    const messages = result.error.issues.map((i) => i.message);
    return `Config validation failed: ${messages.join(', ')}`;
  }
  return null;
}
